import  "./styles/aboutUs.css";
import NavBar from "../Components/Common/navBar";
import Footer from "../Components/Common/footer";
import CompanyIcons from "../Components/CompanyIcons/companyIcons";

const aboutUs = () => {
    return (
        <div className="aboutUsPage">
            <NavBar />
            <div className="aboutUsContainer">
                <div className="aboutUsContent">
                    <img className="aboutUsImage_1" src="about-us-p1.jpg" alt="About Us"></img>
                    <div className="aboutUs_paragraph">
                        <h1>who we are</h1>
                        <h2>Established in 2019</h2>
                        <p>Glitter Paper Designs has a unique US-based design and development team with over 20+ years of industry expertise in the consumer products industry.</p>
                        <p>Our team is passionate about creating inspiring products and our designs are meticulously created to captivate the eye and elevate the art of gifting. We have unique print finishes that transform the simple act of presenting a gift into a delightful experience.</p>
                        <p>We collaborate with the most inspiring and talented product designers worldwide to ensure a distinct point of differentiation in everything we create.</p>
                        <p>Our trend forecasts, marketplace analysis, innovation, and sustainability solutions make us leaders in our seasonal categories.</p>
                        <p>Through a strategic partnership with an Asian manufacturer, we operate on a direct-to-factory model, ensuring unparalleled value and quality for all our customers.</p>
                        <p>We look forward to partnering with you to make a great product.</p>
                    </div>
                </div>
            </div>

            <div className="aboutUsContainer">
                <div className="aboutUsContent">
                    <div className="aboutUs_paragraph">
                        <h2>OUR MISSON:</h2>
                        <p>Our mission is to build lasting relationships with our customers by providing quality products and unique designs at the most competitive prices.</p>
                        
                        <h2>OUR VISION:</h2>
                        <p>We aspire to become the premier destination for design and product development, a company that our customers enthusiastically choose to collaborate with.</p>

                        <h2>OUR VALUES:</h2>
                        <p>We have deep respect for our colleagues while striving to make a difference in everything we do, from product design to sustainability.  Placing our customer’s needs first as we drive value and most importantly, we like to have fun in everything we do!</p>
                    </div>
                    <img className="aboutUsImage_2" src="about-us-p2.jpg" alt="About Us"></img>
                </div>
            </div>

            <div className="careersContainer">
                <div className="careersParagraph">
                    <h2>CAREERS</h2>
                    <p>We cultivate a distinctive and adaptable work environment, in our small but growing team. We are all passionate about working together to achieve great things. Guided by our core values, we prioritize the enjoyment of every endeavor, considering it among our most significant principles in conducting business.</p>
                    <p>At Glitter Paper Designs, every team member is offered the chance to learn, evolve, and feel like they are a valued part of our workforce regardless of ability, age, cultural background ethnicity, faith, gender, gender expression, gender identity, ideology, income, national origin, race or sexual orientation and can contribute meaningfully and feel empowered to help the team make a difference and reach their full potential with dignity.</p>
                </div>
            </div>

            <div className="openPositionsContainer">
                <div className="openPositionsParagraph">
                    <h2>OPEN POSITIONS</h2>
                    <p>There are no current openings. Check back soon for updates!</p>
                </div>
            </div>

            <div className="greatProductsContainer">
                <div className="greatProductsParagraph">
                    <h2>We like to partner with our customers to make GREAT products.</h2>
                    <p>We cherish our collaborations with retail partners, nurturing strong relationships to co-create exceptional designs and products. Our joint efforts aim for optimal sell-through, ensuring the success of our shared endeavors.</p>
                </div>
            </div>
            <CompanyIcons />
            <Footer />
        </div>
    )    
}


export default aboutUs;